import { Injectable } from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { EndPoints } from 'src/@shared/enum';
import type { IdParam, JsonRecord } from './types/api-payloads.types';

@Injectable({
  providedIn: 'root',
})
export class CommonPagesOperationsService {
  constructor(private _cS: CommonService) {}

  AddOrUpdateAnnouncement(requestBody: JsonRecord) {
    return this._cS.API_POST(
      EndPoints.AddOrUpdateAnnouncement,
      requestBody,
      false
    );
  }

  AddOrUpdateBAdges(badgeData: JsonRecord) {
    return this._cS.API_POST(EndPoints.AddOrUpdateBadge, badgeData);
  }

  createUnderReview(underReviewData: JsonRecord) {
    return this._cS.API_POST(EndPoints.CreateUnderReview, underReviewData);
  }
  updateUnderReview(underReviewData: JsonRecord) {
    return this._cS.API_POST(EndPoints.UpdateUnderReview, underReviewData);
  }
  updateTransactionUnderReview(underReviewData: JsonRecord) {
    return this._cS.API_POST(
      EndPoints.UpdateTransactionUnderReview,
      underReviewData
    );
  }
  getAllInvestmentUnderReview() {
    return this._cS.API_GET(EndPoints.GetAllInvestmentUnderReview, false);
  }
  getAllPaymentUnderReview() {
    return this._cS.API_GET(EndPoints.GetAllPaymentUnderReview, false);
  }
  getEmailPaymentDetails(investmentId: IdParam, link: string) {
    return this._cS.API_GET(
      EndPoints.GetEmailPaymentDetails +
        `?paymentId=${investmentId}&paybevLink=${link}`,
      false
    );
  }
  getEmailExpenseDetails(expenseId: IdParam, link: string) {
    return this._cS.API_GET(
      EndPoints.GetEmailExpenseDetails +
        `?paymentId=${expenseId}&PaybevLink=${link}`,
      false
    );
  }
  SendPaymentExpenseIssueEmail(emailData: JsonRecord) {
    return this._cS.API_POST(
      EndPoints.SendPaymentExpensesIssueEmail,
      emailData
    );
  }

  getRetailProgramForSupplier() {
    return this._cS.API_GET(EndPoints.GetRetailProgramForCheckBox, false);
  }
  getRetailSupplierCodes() {
    return this._cS.API_GET(EndPoints.GetRetailSupplierCodes, false);
  }

  AddRetailPrograms(requestBody: JsonRecord) {
    return this._cS.API_POST(EndPoints.AddRetailProgram, requestBody, false);
  }
  UpdateRetailPrograms(requestBody: JsonRecord) {
    return this._cS.API_POST(EndPoints.UpdateRetailProgram, requestBody, false);
  }

  UpdateRetailProgramEmailDefaults(requestBody: JsonRecord) {
    return this._cS.API_POST(
      EndPoints.UpdateRetailProgramEmailDefaults,
      requestBody,
      false
    );
  }
}
